<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
               <div class="row">
                <div class="col-12 d-flex justify-content-between">
                    <h3 class="font-weight-bold">Destination</h3>
                    <button v-if="user.role == 3" type="button" 
                      @click="showBranchModal(0, branch)"  class="btn btn-primary me-2">Add Destination</button>
                </div>
            </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row mb-3">
                    <div class="col-sm-6 col-md-9 col-12 stretch-card col-grid">
                        
                    </div>
                   <div class="col-sm-6 col-md-3 col-8 stretch-card col-grid">
                        <input type="text" v-model="this.filter_branch"
                                               class="form-control w-100"
                                                placeholder="Filter Branches or Region">
                    </div>
                </div>

                 <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                                             <div class="space-y"></div>
    <div class="row">
       
        <div v-for="(branch, index) in paginatedBranches" :key="branch.id" :id="'branch_'+branch.id" class="col-sm-6 col-md-4 grid-margin stretch-card">
            <div class="card tale-bg">
                <div class="card-people mt-auto">
                    <img class="package-branch-img" :src="$store.state.img_url + branch.thumbnail" height="100%" :alt="branch.name">
                    <div class="weather-info">
                        <div class="d-flex">
                            <div class="ms-2">
                                <h3 class="location font-weight-normal">{{branch.name}}</h3>
                                <h4 class="font-weight-normal">{{branch.region}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-2">
                    <button type="button" @click="viewBranch(branch)" class="btn view_btn btn-info btn-icon">
                        <i class="ti-eye"></i>
                    </button>
                    <button type="button" @click="showBranchModal(1, branch)" class="edit_btn btn btn-success btn-icon">
                        <i class="fa fa-edit"></i>
                    </button>
                    <button type="button" @click="deleteBranch(branch.id)"
                        class="delete_btn btn btn-danger btn-icon">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
        
    </div>
        
                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
            </div>
        </div>
    </div>

    <!-- edit modal-->
<div class="modal fade mobile-full-width" id="editModal" tabindex="-1" data-bs-backdrop="static"
    data-bs-keyboard="false" role="dialog" aria-labelledby="editModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">

        <div class="modal-content">
            <div class="modal-header">
                <h4 class="font-weight-bold">{{ this.form_label }}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="container mt-3 mb-3">
                <div id="edit_form">
                    <div class="edit-post-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-8">
                                <div class="row">
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="">Region *</label>
                                            <select v-model="this.branch.region" class="form-select form-control">
                                                <option value="Arusha">Arusha</option>
                                                <option value="Dar es Salaam"> Dar es Salaam</option>
                                                <option value="Dodoma">Dodoma</option>
                                                <option value="Geita">Geita</option>
                                                <option value="Iringa">Iringa</option>
                                                <option value="Kagera">Kagera</option>
                                                <option value="Kahama">Kahama</option>
                                                <option value="Katavi">Katavi</option>
                                                <option value="Karagwe">Karagwe</option>
                                                <option value="Kigoma">Kigoma</option>
                                                <option value="Kilimanjaro">Kilimanjaro</option>
                                                <option value="Lindi">Lindi</option>
                                                <option value="Manyara">Manyara</option>
                                                <option value="Mara">Mara</option>
                                                <option value="Mbeya">Mbeya</option>
                                                <option value="Morogoro">Morogoro</option>
                                                <option value="Mtwara">Mtwara</option>
                                                <option value="Musoma">Musoma</option>
                                                <option value="Mwanza">Mwanza</option>
                                                <option value="Njombe">Njombe</option>
                                                <option value="Pemba">Pemba</option>
                                                <option value="Pwani">Pwani</option>
                                                <option value="Rukwa">Rukwa</option>
                                                <option value="Ruvuma">Ruvuma</option>
                                                <option value="Shinyanga">Shinyanga</option>
                                                <option value="Simiyu">Simiyu</option>
                                                <option value="Singida">Singida</option>
                                                <option value="Songwe">Songwe</option>
                                                <option value="Tabora">Tabora</option>
                                                <option value="Tanga">Tanga</option>
                                                <option value="Zanzibar">Zanzibar</option>
                                            </select>
                                           
                                        </div>
                                        <div class="form-group">
                                            <label class="">District *</label>
                                            <input v-model="this.branch.district" class="form-control" maxlength="25"
                                                required type="text" placeholder="Temeke">
                                        </div>
                                    </div>

                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Location *</label>
                                            <input v-model="this.branch.location" class="form-control" maxlength="60"
                                                required type="text" placeholder="Ward or street">
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Branch name *</label>
                                            <input v-model="this.branch.name" class="form-control" maxlength="15" required
                                                type="text" placeholder="any name eg Shekilango">
                                        </div>
                                    </div>

                                     <div class="col-sm-12 col-md-12">
                                        <label class="form-label">Contacts *</label>
                                        <input v-model="this.branch.contact" class="form-control" maxlength="60" minlength="10" required type="text"
                                            placeholder="0752129251, 0764396994">
                                    </div>

                                    <div class="col-sm-12 col-md-12">
                                        <div class="form-group mt_2">
                                            <label class="form-label">Description*</label>
                                            <textarea v-model="this.branch.description" class="form-control" rows="5"
                                                style="width: 100% !important;"
                                                placeholder="Any additional details…"></textarea>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-sm-6 col-md-4 mb-3">

                                <div class="form-group">
                                    <div class="form-group">
                                        <label class="">Status *</label>
                                        <select v-model="this.branch.status" class="form-select form-control">
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <img :src="$store.state.img_url + this.branch.thumbnail" alt="" width="300px" height="180px" class="user-profile-img">
                                </div>

                                <!--div class="w-100">
                                    <label class="form-label">Choose branch Image or leave a default image (width 400px
                                        height 250px)*</label>
                                    <img id="thumb_edit" width="300px" height="180px" src="" class="user-profile-img"
                                        alt="">
                                </div-->
                                <!--div class="drag-file-area">
                                    <label class="label"><span class="browse-files"> 
                                        <input name="thumbnail" type="file"
                                                accept="image/*"
                                                onchange="document.getElementById('thumb_edit').src = window.URL.createObjectURL(this.files[0])"
                                                class="default-file-input" /> <span class="browse-files-text">browse
                                                file</span></span> </label>
                                </div-->

                            </div>
                        </div>
                    </div>
                    <div class="create-post-bottom">
                        <button @click="createUpdated()" class="btn btn-primary" type="button">{{ this.form_label }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- view modal-->
<div class="modal fade mobile-full-width" id="viewModal" tabindex="-1" data-bs-backdrop="static"
    data-bs-keyboard="false" role="dialog" aria-labelledby="viewModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">

        <div class="modal-content">
            <div class="modal-header">
                <h4 class="font-weight-bold">Branch Info</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div id="branch-content" class="container mt-3 mb-3 ">

                <div v-if="loading_details" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                                           

<div class="row" v-if="user.role > 1">
     <h5>Data Summary</h5>

    <div class="col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-tale">
            <div class="card-body">

                <p id="view-sent" class="fs-25 mt-3"><PriceFormat :Price="data.sent"/></p>
                <p>Sent Packages</p>
            </div>
        </div>
    </div>
    <div class="col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-tale">
            <div class="card-body">

                <p id="view-received" class="fs-25 mt-3"><PriceFormat :Price="data.received"/></p>
                <p>Received Packages</p>
            </div>
        </div>
    </div>
    <div class="col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-dark-blue">
            <div class="card-body">

                <p id="view-trashed" class="fs-25 mt-3"><PriceFormat :Price="data.trashed"/></p>
                <p>Trashed Packages</p>
            </div>
        </div>
    </div>
    <div class="col-sm-6 col-md-3 mb-4 stretch-card transparent">
        <div class="card card-dark-blue">
            <div class="card-body">

                <p id="view-revenue" class="fs-25 mt-3"><PriceFormat :Price="data.revenue"/>/=</p>
                <p>Total Revenue</p>
            </div>
        </div>
    </div>
</div>

<h5 class="mt-3">Branch Details</h5>
<div class="row">
    <div class="col-sm-6 col-md-4 grid-margin stretch-card">
        <div class="card tale-bg">
            <div class="card-people mt-auto">
                <img class="package-branch-img" id="view-img" :src="$store.state.img_url + branch.thumbnail" alt="">
                <div class="weather-info">
                    <div class="d-flex">
                        <div class="ms-2">
                            <h3 id="edit-pname" class="location font-weight-normal"></h3>
                            <h4 id="edit-bname" class="font-weight-normal"></h4>
                            <h4 id="edit-pprice" class="font-weight-normal"></h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-6 col-md-4">
 <p>
            <b>Branch name:</b><br>
            {{branch.name}}
        </p>
        <p>
            <b>Place :</b><br>
            {{branch.region}} {{branch.district}}
        </p>
        <p>
            <b>Branch Location:</b><br>
            {{branch.location}}
        </p>
    </div>

    <div class="col-sm-6 col-md-4">
        <p id="view-description">
            <b>Branch Description:</b><br>
            {{branch.description}}
        </p>
        <div class="mt-3"></div>
        <p id="view-description">
            <b>Contacts:</b><br>
            {{branch.contact}}
        </p>
    </div>

</div>

<h5 class="mt-3">Staff Members</h5>

<div class="row">
    <div class="col-12">
        <div class="table-responsive">

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>No</th>
                        <th> User name </th>
                        <th> Full name </th>
                        <th> Phone no </th>
                        <th> Role </th>
                    </tr>
                </thead>
                <tbody id="staff-list">

                   
                    <tr id="staff_{{this.id}}" v-for="(staff, index) in staffs" :key="staff.id">
                        <td class="py-1">
                            {{index + 1}}
                        </td>
                        <td> {{staff.username}} </td>
                        <td> {{staff.fulname}}</td>
                        <td>
                            {{staff.phone1}}
                        </td>
                        <td>
                            <label v-if="staff.role == 3" class="badge badge-danger">Super manager</label>
                            <label v-if="staff.role == 2" class="badge badge-success">Branch manager</label>
                            <label v-if="staff.role == 1" class="badge badge-info">Branch staff</label>
                        </td>

                    </tr>
                    
                </tbody>
            </table>
        </div>
    </div>
</div>

            </div>
        </div>
    </div>
</div>



</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_details: false,
            branches: [],
            og_branches: [],
            filter_branch: "",
            regions:[],
            staffs:[],
            data:{},
            parcel: {},
            currentPage: 1,
            perPage: 20,
            form_label :"Create Branch",
            branch:{
                id: 0,
                contact: '',
                region: '',
                name: '',
                thumbnail: 'branch.jpg',
                description: 'new branch',
                district: '',
                location: '',
                status: 1,
            },
            user: this.$attrs.user
        };
    },
    methods: {

        showBranchModal(type, branch){

            if(type == 0){
                this.branch = {
                id: 0,
                contact: '',
                region: '',
                name: '',
                thumbnail: 'branch.jpg',
                description: 'new branch',
                district: '',
                location: '',
                status: 1,
            }

            this.form_label = "Create Branch"
            }else{
                this.branch = branch
                this.form_label = "Update Branch"
            }

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("editModal")
            );

            modal.show();
        },

        async getAllBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/all-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = response.data.branches;
                this.og_branches = response.data.branches;

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

         async createUpdated() {

            var branch = this.branch
            //var branches = this.branches
            //var og_branches = this.og_branches

            var response = await axios
                .post(this.$store.state.api_url + "/branch/create-update",branch)
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                //this.branches = [ branch,...branches];
                //this.og_branches = [ branch,...og_branches];

                window.location.reload();
                
                /*const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("editModal")
            );

            modal.hide();*/

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

              async deleteBranch(id) {

            var branch_id = id
            //var branches = this.branches
            //var og_branches = this.og_branches

            var response = await axios
                .post(this.$store.state.api_url + "/branch/delete",{branch_id})
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                 var message = response.data.message;
                this.$toast.success(message, { duration: 5000, dismissible: true });

               this.branches = this.branches.filter(item => item.id !== branch_id);
               this.og_branches = this.og_branches.filter(item => item.id !== branch_id);

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        async viewBranch(branch) {

              const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("viewModal")
            );

            modal.show();

            this.branch = branch

            var branch_id = branch.id
            //var branches = this.branches
            //var og_branches = this.og_branches
            this.loading_details = true

            var response = await axios
                .post(this.$store.state.api_url + "/branch/view-branch",{branch_id})
                .catch((errors) => {
                     this.loading_details = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                 this.loading_details = false
               this.staffs = response.data.staffs
               this.data = response.data.dataz

            } else {

                 this.loading_details = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },


        async getRegions() {

            var response = await axios
                .get(this.$store.state.api_url + "/received-reports")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.regions = response.data.regions;
               

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedBranches() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.branches.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.branches.length / this.perPage)
  },
  

},
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) ||
                    (branch.region && branch.region.toLowerCase().includes(term))
                )

            })

        }
   
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getAllBranch()
        //this.getRegions()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
